import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const DeliverySelect = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDelivery, setSelectedDelivery] = useState('');
  const dropdownRef = useRef(null);

  const deliveryOptions = [
    { id: 'fast', label: 'Fast' },
    { id: 'extra-fast', label: 'Extra Fast' },
    { id: 'express', label: 'Express' }
  ];

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const deliveryParam = urlParams.get('delivery');
    if (deliveryParam && deliveryOptions.some(option => option.id === deliveryParam)) {
      setSelectedDelivery(deliveryParam);
    }
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const selectDelivery = (serviceId) => {
    setSelectedDelivery(serviceId);
  };

  const clearAll = () => {
    setSelectedDelivery('');

    const url = new URL(window.location);
    url.searchParams.delete('delivery');
    window.location.search = url.searchParams.toString();
  };

  const applyFilters = () => {
    if (selectedDelivery) {
      const url = new URL(window.location);
      url.searchParams.set('delivery', selectedDelivery);
      window.location.search = url.searchParams.toString();
    }
    setIsOpen(false);
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative inline-block w-[80px] md:w-[110px]" ref={dropdownRef}>

      <button
        onClick={toggleDropdown}
        className="flex items-center justify-between w-full px-2 md:px-4 py-1 md:py-2 text-[12px] md:text-sm font-medium text-gray-700 bg-white border border-[#185BC3] rounded-[50px] shadow-sm hover:bg-gray-50 focus:outline-none"
      >
        <span className='text-[#185BC3]'>Delivery</span>
        <ChevronDown className={`w-4 h-4 ml-0 transition-transform text-[#185BC3] font-extrabold duration-200 ${isOpen ? 'transform rotate-180' : ''}`} />
      </button>


      {isOpen && (
        <div className="p-3 absolute z-10 w-64 mt-2 origin-top-right bg-white border border-[#9D9D9D40] rounded-md shadow-[5px]">
          <div className="flex flex-col gap-2">
            <p className='text-black font-medium font-poppins text-[16px]'>Delivery</p>
            <div className="flex flex-col gap-2">
              {deliveryOptions.map((option) => (
                <div key={option.id} className="flex items-center gap-1">
                  <input 
                    type='radio' 
                    name='delivery' 
                    id={option.id}
                    checked={selectedDelivery === option.id}
                    onChange={() => selectDelivery(option.id)}
                    className="accent-[#174568]"
                  />
                  <label 
                    htmlFor={option.id}
                    className={`text-[14px] cursor-pointer ${
                      selectedDelivery === option.id ? 'text-[#174568]' : 'text-[#9D9D9D]'
                    }`}
                  >
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between mt-3">
              <button 
                onClick={clearAll}
                className='border-[1px] border-[#174568] text-[#174568] text-[15px] rounded-[30px] py-[.5px] px-3 hover:bg-gray-50'
              >
                Clear
              </button>
              <button 
                onClick={applyFilters}
                className='border-[1px] bg-[#174568] border-[#174568] text-[15px] text-white rounded-[30px] py-[.5px] px-3 hover:bg-[#0f3a4f]'
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeliverySelect;